// The tenant feature `ceremony` (#163 AI19), as the portal learns it — the
// same shape as src/core/cmsFeature.ts, one rule for both flags.
//
// The flag is server truth: with it off, every ceremony root answers
// FEATURE_DISABLED. The portal has no flag query of its own, so it learns the
// answer from the first ceremony call it makes — the shell's probe for a
// ceremony reader (MainLayout → probeCeremonyFeature) or the tool itself —
// and hides the Award ceremony tool once it knows the feature is off.
// Unknown counts as on: the entry is a first-frame hint like every rail hint,
// and the tool says so in place if the server refuses.
import { reactive } from 'vue'
import type { Client } from '@urql/vue'
import { CeremonyFeatureProbeDocument } from './ceremonyFeature.operations'
import { hasErrorCode } from 'src/modules/cms/cmsRender'

export const ceremonyFeature = reactive({
  /** The server answered FEATURE_DISABLED. */
  off: false,
  /** The shell's probe ran (once per session). */
  probed: false,
})

/** Records what a ceremony answer says about the flag. */
export function noteCeremonyAnswer(error: unknown): void {
  if (hasErrorCode(error, 'FEATURE_DISABLED')) ceremonyFeature.off = true
  else if (!error) ceremonyFeature.off = false
}

/** Asks once per session whether the ceremony service answers. */
export async function probeCeremonyFeature(client: Client): Promise<void> {
  if (ceremonyFeature.probed) return
  ceremonyFeature.probed = true
  try {
    const r = await client.query(CeremonyFeatureProbeDocument, {}).toPromise()
    if (hasErrorCode(r.error, 'FEATURE_DISABLED')) ceremonyFeature.off = true
  } catch {
    // Unreachable is not "off": the tool will say what is wrong.
  }
}

/** Test seam. */
export function resetCeremonyFeature(): void {
  ceremonyFeature.off = false
  ceremonyFeature.probed = false
}
